module.exports = __webpack_public_path__ + "static/img/1_2_1_1.b7e5cde2.jpg";